import axios from 'axios';
import authConfig from '../../auth_config.json';

export default axios.create({
    baseURL: `${authConfig.cameraDomain}/api/v1/`,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    },
})
